export default "__VITE_PUBLIC_ASSET__840d5601__"